import api from './api';
import ErrorService from './errorService';



export const BranchService = {
    getAllBrach: async () => {
      try {
        const response = await ErrorService.withTimeout(api.get('/Branch'));
        return response.data;
    
      } catch (error) {
        ErrorService.handleApiError('Error al obtener Sucursales:', error);
        throw error;
      }
    },
}